export default "__VITE_ASSET__f99dhsFq__"